"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DownloadSidebarSubmitted = void 0;
const react_1 = __importDefault(require("react"));
const Button_1 = require("@Components/Buttons/Button");
const DownloadSidebarSubmitted = (props) => (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("h2", null, "Your files are on the way!"),
    react_1.default.createElement("p", { className: 'large' }, props.subText),
    react_1.default.createElement("div", { className: 'download-button' },
        react_1.default.createElement(Button_1.Button, { mainColor: true, type: 'primary', onClick: () => props.closeSidebar() }, "Done"))));
exports.DownloadSidebarSubmitted = DownloadSidebarSubmitted;
